import { NavLink } from 'react-router-dom';
import type { NavItem } from './navItems';

// Compact bottom navigation for phones (<768px), per v6 architecture §5.
// Capped at 5 items so it stays touch-first and uncluttered on a phone.
// Matches the production app's `.mobile-nav` (blurred dark bar, gold
// active icon) — every target is a full-height tap zone, not a thin strip.
export function BottomNav({ items }: { items: NavItem[] }) {
  const shown = items.slice(0, 5);
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-30 flex h-16 border-t border-ink-border bg-[#0b0c0f]/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-lg tablet:hidden"
      aria-label="Primary"
    >
      {shown.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `flex flex-1 flex-col items-center justify-center gap-1 text-[10px] font-semibold ${isActive ? 'text-gold-200' : 'text-slate-500'}`
          }
        >
          <item.icon className="h-5 w-5" strokeWidth={2.1} aria-hidden="true" />
          <span className="truncate px-0.5">{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
